<div class="nav-top mr-s">
  <span class="idf-select dropdown-toggle" (click)="openIdfSelect()">
    IDF: {{ currentlyDisplayedIdf }}
  </span>
</div>
